// 登录凭证 cookie 的有效期（秒）：30 天。
// 原来不带 max-age 会写成会话级 cookie，关掉浏览器/微信 webview 后登录态就没了，
// 用户下次进来仍要重新登录（CHNA-2793）。
export const AUTH_COOKIE_MAX_AGE = 30 * 24 * 60 * 60

export const setCookie = (key, value, domain, path, maxAgeSeconds) => {
  let cookie = key + '=' + value
  if (domain) {
    cookie += '; domain=' + domain
  }
  if (path) {
    cookie += '; path=' + path
  }
  if (maxAgeSeconds) {
    cookie += '; max-age=' + maxAgeSeconds
  }
  document.cookie = cookie
}

export const setPadiWxId = (value) => {
  const currentHost = document.location.origin
  if (currentHost.indexOf('padi.com.cn') >= 0) {
    delCookie('padiWxId')
    delCookie('padiWxId', 'padi.com.cn', '/')
    setCookie('padiWxId', value, 'padi.com.cn', '/', AUTH_COOKIE_MAX_AGE)
  } else {
    delCookie('padiWxId')
    delCookie('padiWxId', 'padi.com.cn', '/')
    setCookie('padiWxId', value, undefined, undefined, AUTH_COOKIE_MAX_AGE)
  }
}

export const getCookie = (sKey) => {
  if (!sKey) {
    return null
  }
  /* eslint-disable */
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          '(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'
        ),
        '$1'
      )
    ) || null
  )
  /* eslint-enable */
}

export const getUnionId = () => {
  return getCookie('padiWxId')
}

export const delCookie = (name, domain, path) => {
  const cookie = getCookie(name)
  if (!cookie) return
  let expires = new Date()
  expires.setTime(expires.getTime() - 1)
  let cookieToRemove = name + '=; expires=' + expires.toUTCString()
  const currentHost = document.location.origin
  if (currentHost.indexOf('localhost') >= 0) {
    document.cookie = cookieToRemove
    return
  }
  if (domain) {
    cookieToRemove += '; domain=' + domain
  }
  if (path) {
    cookieToRemove += '; path=' + path
  }
  document.cookie = cookieToRemove
}

export const saveStorage = (key, value) => {
  localStorage.setItem(key, value)
}

export const getDataFromStorage = (key) => {
  return localStorage.getItem(key)
}

export const removePadiWxId = () => {
  const currentHost = document.location.origin
  if (currentHost.indexOf('padi.com.cn') >= 0) {
    delCookie('padiWxId', 'padi.com.cn', '/')
  } else {
    delCookie('padiWxId')
  }
  delCookie('wechatToken')
}
